var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results"},[_vm._v("No stories match your search criteria.")])}
var staticRenderFns = []

export { render, staticRenderFns }